import { StyleSheet } from 'react-native'

export const contactStyles = StyleSheet.create({
  button: {
    marginHorizontal: 5,
    marginVertical: 3,
  },
})
